<template>
  <div class="containerDiv">
    <PCNavbar selectIndex="6"/>
    <MobileNavBar :currentActive="5"/>
    <!-- 头部banner图片 -->
    <!-- <img class="bannerImgcss0" src="../img3/dangjian/dangjian-title-bg.png" /> -->
    <a href="https://www.qstheory.cn/zt2025/esjszqh/index.htm"  target="_blank">
         <img  class="bannerImgcss0" src="../assets/w/img3/dangjian/dangjianBg1.png" />
    
    </a>
   
    <!-- 二级菜单切换 -->
    <div class="production_card">
     
      <Menu1 class="menu1css" />
    </div>

    
  </div>
</template>

<script>
import Menu1 from '@/components/dangjiangw/index'

import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome1 from '@/components/carousel_home/index1'


 
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome1,
    Menu1,
  },
  data() {
    return {
      procardList: [
        {
          tit: '集团简介',
        }
      ],
     
      
    }
  },
 

}
</script>

<style lang="scss" scoped>
// .bannerImgcss0{
//   width:100%;
//   margin-top:60px;
//   height:auto;
//   @media screen and (max-width: 768px) {
//     margin-top:1px;
//     }
// }
.menu1css{
  // margin-bottom: 5rem;
}
.containerDiv{
   min-width: 1000px;
  
  .production_card {
    margin-top:-2.5rem;
    // width: 90vw;
    // margin: 0 auto;
    // background: #ffffff;
  }
}
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }

 
}
</style>